export default "/images/0076b89bcb4fecdca9c4fa7401101c52.avif";